import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/help-rsvp-links";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/help/rsvp-links")({
  head: SEO["/help/rsvp-links"],
  component: () => <ContentPage path="/help/rsvp-links" body={body} />,
});
